module.exports = __webpack_public_path__ + "static/step6-340174d6586d3a4773af88851356a568.png";